import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TestimonailsService } from 'src/app/services/testimonails.service';
import { Testimonial } from 'src/app/models/testimonial';
import { Router } from '@angular/router';

@Component({
  selector: 'app-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss']
})
export class TestimonialsComponent implements OnInit {
  public testimonials = new BehaviorSubject<Testimonial>(null);
  public testimonialsLoaded:boolean=false;
  private perPage=20;

  constructor(
    private _testimonial: TestimonailsService,
    private _router: Router
  ) { }

  getTestimonials(page){
    this._testimonial.getTestimonials(page, this.perPage).subscribe(
      res=>{
        this.testimonials.next(res);
        this.testimonialsLoaded=true;
      }
    );
  }

  newTestimonial(){
    if(!confirm('Confirm that you want to add a new Testimonial to the system')) return false;
    let t=new Testimonial({});
    this._testimonial.createTestimonial(t).subscribe(
      res=>{
        this._router.navigate(['/testimonials/'+res.id]);
      }
    );
  }

  ngOnInit() {
    this.getTestimonials(1);
  }

  pageChanged(data){
    this.perPage=data.pageSize;
    this.getTestimonials(data.pageIndex+1);
  }

  perPageChanged(data){
    this.perPage=data.pageSize;
    this.getTestimonials(1);
  }

}
